export type { FileStatusResult } from "~/state/machines/git/gitStatus.machine";

export * from "./types";

export const parsePageIdFromPath = (path: string) => {
	return path.split("/").at(-2)?.replace(/page_/, "");
};

export const GIT_PUBLISHING_BRANCH_NAME = "main";
export const GIT_PUBLISHING_REMOTE_NAME = "moment";
